import { createURL } from '@sm/utils';
import { t, defineMessages } from '@sm/intl';

const COPY = defineMessages({
  MY_ACCOUNT: {
    id: 'getUserLinks.myAccount',
    defaultMessage: 'My Account',
    description:
      '[Type: Label][Vis.: high] - This is the My account dropdown on the header.',
  },
  SWITCH_ACCOUNTS: {
    id: 'getUserLinks.switchAccount',
    defaultMessage: 'Switch accounts',
    description:
      '[Type: Label][Vis.: high] - This is the Switch accounts link in the user dropdown.',
  },
  MY_TEAM: {
    id: 'getUserLinks.myTeam',
    defaultMessage: 'My Team',
    description:
      '[Type: Label][Vis.: high] - This is the My teams section of the userdrop down.',
  },
  LIBRARY: {
    id: 'getUserLinks.library',
    defaultMessage: 'Library',
    description:
      '[Type: Label][Vis.: high] - This is the Library link in the userdrop down.',
  },
  CONTACTS: {
    id: 'getUserLinks.contacts',
    defaultMessage: 'Contacts',
    description:
      '[Type: Label][Vis.: high] - This is the contacts link in the userdrop down.',
  },
  BENCHMARKS: {
    id: 'getUserLinks.benchmarks',
    defaultMessage: 'Benchmarks',
    description:
      '[Type: Label][Vis.: high] - This is the benchmarks link in the userdrop down.',
  },
  SIGN_OUT: {
    id: 'getUserLinks.sign_out',
    defaultMessage: 'Sign Out',
    description:
      '[Type: Label][Vis.: high] - This is the sign out link in the userdrop down.',
  },
});

const getUserLinks = (
  isNonEnterpriseGroupAdmin,
  paidBenchmarksEnabled,
  libraryEnabled,
  plansBenchmarksEnabled,
  isEnterpriseAccount,
  lang,
  isEUDC,
  hasMultipleLinkedIdentities
) => {
  const userLinks = [
    {
      path: createURL('/user/account/', { ut_source: 'header' }),
      name: t(COPY.MY_ACCOUNT),
    },
    ...(hasMultipleLinkedIdentities
      ? [
          {
            path: createURL('/user/account/select/', { ut_source: 'header' }),
            name: t(COPY.SWITCH_ACCOUNTS),
          },
        ]
      : []),
    ...(isNonEnterpriseGroupAdmin
      ? [
          {
            path: createURL('/team', { ut_source: 'header' }),
            name: t(COPY.MY_TEAM),
          },
        ]
      : []),
    ...(!isEnterpriseAccount && libraryEnabled
      ? [
          {
            path: createURL('/team/library', { ut_source: 'header' }),
            name: t(COPY.LIBRARY),
          },
        ]
      : []),
    {
      path: createURL('/addressbook/', { ut_source: 'header' }),
      name: t(COPY.CONTACTS),
    },
    ...(((lang === 'en' && plansBenchmarksEnabled) || paidBenchmarksEnabled) &&
    !isEUDC
      ? [
          {
            path: createURL('/benchmarks/home/', {
              ut_source: 'header_username_menu',
              ut_source2: 'wide_menu',
            }),
            name: t(COPY.BENCHMARKS),
          },
        ]
      : []),
    {
      path: createURL('/user/sign-out/', { ut_source: 'header' }),
      name: t(COPY.SIGN_OUT),
    },
  ];
  return userLinks;
};

export default getUserLinks;
